import contactRelationshipSelectors from 'selectors/onboarding/contactRelationships'
import contactRoleSelectors from 'selectors/onboarding/contactRoles'
import documentSelectors from 'selectors/onlineExperience/documents'
import investmentPlanSelectors from 'selectors/onlineExperience/investmentPlans'
import onlineExperienceTypeSelectors from 'selectors/onlineExperience/onlineExperienceTypes'
import teamMemberSelectors from 'selectors/onlineExperience/teamMembers'
import portfolioSelectors from 'selectors/onlineExperience/portfolio'
import selectors from 'selectors'

export default {
  ...contactRelationshipSelectors,
  ...contactRoleSelectors,
  ...documentSelectors,
  ...onlineExperienceTypeSelectors,
  ...investmentPlanSelectors,
  ...portfolioSelectors,
  ...selectors,
  ...teamMemberSelectors
}



// WEBPACK FOOTER //
// ./src/selectors/index.js